import { Alert, SpaceBetween } from "@amzn/awsui-components-console";
import React from "react";

import EvalDatasetTable from "@/components/eval-dataset/EvalDatasetTable";
import useAdminEvalDataset from "@/hooks/admin/useAdminEvalDataset";

const AdminEvalDatasetPage: React.FC = () => {
  const { cases, loading, saving, seeding, loadCases, upsertCase, deleteCase, seedFromBaseline } =
    useAdminEvalDataset();

  return (
    <SpaceBetween size="l">
      <Alert type="info" header="How this works">
        Each row is a test case used to measure how well the agent answers questions.
        When the evaluation runs, it asks the agent each question and scores the response
        against the expected answer. Add new cases by clicking "Add case," providing the
        question and expected answer. The SQL field is optional for non-technical users.
        Use tags to organize cases and filter runs (e.g. "smoke" for quick manual checks,
        "full" for the scheduled daily run).
      </Alert>
      <EvalDatasetTable
        cases={cases}
        loading={loading}
        saving={saving}
        seeding={seeding}
        onRefresh={loadCases}
        onUpsert={upsertCase}
        onDelete={deleteCase}
        onSeed={seedFromBaseline}
      />
    </SpaceBetween>
  );
};

export default AdminEvalDatasetPage;
